module.exports = __webpack_public_path__ + "img/backup-feedback-icon.4a371123.svg";